import styled from "styled-components";
import { withAntComponent } from "../../hoc/withAntComponent";
import MaskedInput from "antd-mask-input";

const CodeInput = styled(MaskedInput)`
    &.ant-input {
        text-align: center;
        border-radius: 8px;
        border-color: ${({ theme: { colors } }) => colors.primary};
        color: ${({ theme: { colors } }) => colors.primary};
        font-size: 20px;
        font-weight: 700;
    }
`;

export default withAntComponent(CodeInput);
